import React, { FC } from 'react';

interface IPublicRoutesProps {
  layout: FC<any>,
  component: FC<any>;
  children?: React.ReactNode;
}
const PublicRoutes: FC<IPublicRoutesProps> = ({ layout:Layout, component: Component, children }) => {
  return (
    <Layout>
      <Component>
        {children}
      </Component>
    </Layout>
  );
}

export default PublicRoutes;
